export function Stars({className, size = 18}) {
  return (
    <div className={'stars' + (className ? ' ' + className : '')}>
      {Array.from(Array(5), (e, i) =>
        <img key={i} src={'/static/img/icon/star.svg'} loading={'lazy'} alt="★" width={size} height={size}/>
      )}
    </div>
  )
}
